import { render, staticRenderFns } from "./BlockedPracticeModal.vue?vue&type=template&id=1537591f&v-if=currentUser.is_medical_rep&"
import script from "./BlockedPracticeModal.vue?vue&type=script&lang=ts&"
export * from "./BlockedPracticeModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports